<template lang="pug">
     .announce.green(
        :class='content.theme',
        v-observe-visibility='visibilityChanged'
        )
        .announce__container
            .announce__decor.announce__decor_phone
                img(src='@/assets/img/articles/part-2/phone.png')
            .announce__decor.announce__decor_pistol
                img(src='@/assets/img/articles/part-2/pistol.png')
            .announce__title(v-html='content.title') 
</template>
<script>
export default {
    components: {
        ArticleTitle: () => import('../components/ArticleTitle.vue')
    },
    data() {
        return {
            isActive: false
        };
    },
    props: {
        theme: String,
        content: Object
    },
    methods: {
        visibilityChanged(isVisible) {
            if (isVisible) this.isActive = true;
            else this.isActive = false;
        }
    }
};
</script>
<style lang="scss">
@import '../assets/css/vars.scss';
.announce {
    background: url(../assets/img/articles/tree.jpg) center / cover no-repeat;
    overflow: hidden;
    &__container {
        padding: 80px 0;
        margin: 0 auto;
        max-width: var(--grid-width);
        width: 100%;
        position: relative;
        @media (--viewport-laptop) {
            padding-left: var(--grid-column-laptop);
            padding-right: var(--grid-column-laptop);
        }
        @media (--viewport-tablet) {
            padding: 30px 0 50px;
            padding-left: var(--grid-column-mobile);
            padding-right: var(--grid-column-mobile);
        }
    }
    &__title {
        font-family: var(--font-accent);
        font-weight: bold;
        font-size: 96px;
        color: var(--color-white);
        line-height: 1;
        z-index: 5;
        position: relative;
        z-index: 1;
        padding: 0.5em 0;
        @media (--viewport-laptop) {
            font-size: 9vw;
        }
        &::before,
        &::after {
            content: '';
            background: url(../assets/img/border-white.svg) center left / contain;
            position: absolute;
            width: calc(var(--grid-column) * 7);
            height: 5px;
            left: 0;
            border-radius: 5px;
            @media screen and (--viewport-laptop) {
                width: calc(var(--grid-column-laptop) * 7);
            }
            @media screen and (--viewport-tablet) {
                width: calc(var(--grid-column-mobile) * 5);
            }
        }
        &::before {
            top: 0;
        }
        &::after {
            bottom: 0;
        }
    }
    &__decor {
        position: absolute;
        img {
            display: block;
            width: 100%;
        }
        &_phone {
            top: 0;
            right: 0;
            transform: translate(35%, -65%);
            z-index: 3;
            width: 45vw;
            max-width: 571px;
            @media screen and (--viewport-laptop) {
                transform: translate(0, -70%);
                width: 50vw;
            }
            @media screen and (--viewport-tablet) {
                // transform: translate(0, -70%);
                width: 60vw;
            }
        }
        &_pistol {
            bottom: 0;
            right: 0;
            transform: translate(30%, 40%);
            width: 25vw;
            max-width: 326px;
            @media screen and (--viewport-laptop) {
                transform: translate(0, 35%);
                width: 35vw;
            }
            @media screen and (--viewport-tablet) {
                // transform: translate(0, 45%);
                width: 40vw;
            }
        }
    }
}
</style>
